"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Message Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.75
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotTargetApi = exports.SlotTargetApiFactory = exports.SlotTargetApiFp = exports.SlotTargetApiAxiosParamCreator = exports.SlotGroupApi = exports.SlotGroupApiFactory = exports.SlotGroupApiFp = exports.SlotGroupApiAxiosParamCreator = exports.MulticastGroupApi = exports.MulticastGroupApiFactory = exports.MulticastGroupApiFp = exports.MulticastGroupApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FarmApi = exports.FarmApiFactory = exports.FarmApiFp = exports.FarmApiAxiosParamCreator = exports.EndDeviceApi = exports.EndDeviceApiFactory = exports.EndDeviceApiFp = exports.EndDeviceApiAxiosParamCreator = exports.IEventTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.IEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 * EndDeviceApi - axios parameter creator
 * @export
 */
var EndDeviceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create end device.
         * @param {ICreateEndDeviceRequestDTO} [iCreateEndDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEndDevice: function (iCreateEndDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/end-device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateEndDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEndDeviceByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteEndDeviceByID', 'id', id);
                    localVarPath = "/message/end-device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all end devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEndDevices: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/end-device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all end devices by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEndDevicesByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllEndDevicesByFarmID', 'farmId', farmId);
                    localVarPath = "/message/end-device/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEndDeviceByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getEndDeviceByID', 'id', id);
                    localVarPath = "/message/end-device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {IUpdateEndDeviceRequestDTO} [iUpdateEndDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEndDeviceByID: function (id, iUpdateEndDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateEndDeviceByID', 'id', id);
                    localVarPath = "/message/end-device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateEndDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.EndDeviceApiAxiosParamCreator = EndDeviceApiAxiosParamCreator;
/**
 * EndDeviceApi - functional programming interface
 * @export
 */
var EndDeviceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EndDeviceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create end device.
         * @param {ICreateEndDeviceRequestDTO} [iCreateEndDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEndDevice: function (iCreateEndDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createEndDevice(iCreateEndDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEndDeviceByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteEndDeviceByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all end devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEndDevices: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllEndDevices(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all end devices by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEndDevicesByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllEndDevicesByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEndDeviceByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEndDeviceByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {IUpdateEndDeviceRequestDTO} [iUpdateEndDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEndDeviceByID: function (id, iUpdateEndDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateEndDeviceByID(id, iUpdateEndDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EndDeviceApiFp = EndDeviceApiFp;
/**
 * EndDeviceApi - factory interface
 * @export
 */
var EndDeviceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EndDeviceApiFp)(configuration);
    return {
        /**
         * Create end device.
         * @param {ICreateEndDeviceRequestDTO} [iCreateEndDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEndDevice: function (iCreateEndDeviceRequestDTO, options) {
            return localVarFp.createEndDevice(iCreateEndDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEndDeviceByID: function (id, options) {
            return localVarFp.deleteEndDeviceByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all end devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEndDevices: function (options) {
            return localVarFp.getAllEndDevices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all end devices by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEndDevicesByFarmID: function (farmId, options) {
            return localVarFp.getAllEndDevicesByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEndDeviceByID: function (id, options) {
            return localVarFp.getEndDeviceByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update end device by ID.
         * @param {string} id Unique ID of end device.
         * @param {IUpdateEndDeviceRequestDTO} [iUpdateEndDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEndDeviceByID: function (id, iUpdateEndDeviceRequestDTO, options) {
            return localVarFp.updateEndDeviceByID(id, iUpdateEndDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EndDeviceApiFactory = EndDeviceApiFactory;
/**
 * EndDeviceApi - object-oriented interface
 * @export
 * @class EndDeviceApi
 * @extends {BaseAPI}
 */
var EndDeviceApi = /** @class */ (function (_super) {
    __extends(EndDeviceApi, _super);
    function EndDeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create end device.
     * @param {ICreateEndDeviceRequestDTO} [iCreateEndDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndDeviceApi
     */
    EndDeviceApi.prototype.createEndDevice = function (iCreateEndDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.EndDeviceApiFp)(this.configuration).createEndDevice(iCreateEndDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete end device by ID.
     * @param {string} id Unique ID of end device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndDeviceApi
     */
    EndDeviceApi.prototype.deleteEndDeviceByID = function (id, options) {
        var _this = this;
        return (0, exports.EndDeviceApiFp)(this.configuration).deleteEndDeviceByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all end devices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndDeviceApi
     */
    EndDeviceApi.prototype.getAllEndDevices = function (options) {
        var _this = this;
        return (0, exports.EndDeviceApiFp)(this.configuration).getAllEndDevices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all end devices by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndDeviceApi
     */
    EndDeviceApi.prototype.getAllEndDevicesByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.EndDeviceApiFp)(this.configuration).getAllEndDevicesByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get end device by ID.
     * @param {string} id Unique ID of end device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndDeviceApi
     */
    EndDeviceApi.prototype.getEndDeviceByID = function (id, options) {
        var _this = this;
        return (0, exports.EndDeviceApiFp)(this.configuration).getEndDeviceByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update end device by ID.
     * @param {string} id Unique ID of end device.
     * @param {IUpdateEndDeviceRequestDTO} [iUpdateEndDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndDeviceApi
     */
    EndDeviceApi.prototype.updateEndDeviceByID = function (id, iUpdateEndDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.EndDeviceApiFp)(this.configuration).updateEndDeviceByID(id, iUpdateEndDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EndDeviceApi;
}(base_1.BaseAPI));
exports.EndDeviceApi = EndDeviceApi;
/**
 * FarmApi - axios parameter creator
 * @export
 */
var FarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create farm context.
         * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmContext: function (iCreateFarmContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/farm/context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateFarmContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFarmContextByID', 'id', id);
                    localVarPath = "/message/farm/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farm contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmContexts: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/farm/context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farm lora settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLoraSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/farm/settings/lora";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmContextByID', 'id', id);
                    localVarPath = "/message/farm/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm lora settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLoraSettingsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmLoraSettingsByID', 'id', id);
                    localVarPath = "/message/farm/settings/lora/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmContextByID: function (id, iUpdateFarmContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmContextByID', 'id', id);
                    localVarPath = "/message/farm/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm lora settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmLoraSettingsRequestDTO} [iUpdateFarmLoraSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLoraSettingsByID: function (id, iUpdateFarmLoraSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmLoraSettingsByID', 'id', id);
                    localVarPath = "/message/farm/settings/lora/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmLoraSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmApiAxiosParamCreator = FarmApiAxiosParamCreator;
/**
 * FarmApi - functional programming interface
 * @export
 */
var FarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create farm context.
         * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmContext: function (iCreateFarmContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFarmContext(iCreateFarmContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFarmContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farm contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmContexts: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmContexts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farm lora settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLoraSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmLoraSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm lora settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLoraSettingsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmLoraSettingsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmContextByID: function (id, iUpdateFarmContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmContextByID(id, iUpdateFarmContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm lora settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmLoraSettingsRequestDTO} [iUpdateFarmLoraSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLoraSettingsByID: function (id, iUpdateFarmLoraSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmLoraSettingsByID(id, iUpdateFarmLoraSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmApiFp = FarmApiFp;
/**
 * FarmApi - factory interface
 * @export
 */
var FarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmApiFp)(configuration);
    return {
        /**
         * Create farm context.
         * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarmContext: function (iCreateFarmContextRequestDTO, options) {
            return localVarFp.createFarmContext(iCreateFarmContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmContextByID: function (id, options) {
            return localVarFp.deleteFarmContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farm contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmContexts: function (options) {
            return localVarFp.getAllFarmContexts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farm lora settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmLoraSettings: function (options) {
            return localVarFp.getAllFarmLoraSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmContextByID: function (id, options) {
            return localVarFp.getFarmContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm lora settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmLoraSettingsByID: function (id, options) {
            return localVarFp.getFarmLoraSettingsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm context by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmContextByID: function (id, iUpdateFarmContextRequestDTO, options) {
            return localVarFp.updateFarmContextByID(id, iUpdateFarmContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm lora settings by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmLoraSettingsRequestDTO} [iUpdateFarmLoraSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmLoraSettingsByID: function (id, iUpdateFarmLoraSettingsRequestDTO, options) {
            return localVarFp.updateFarmLoraSettingsByID(id, iUpdateFarmLoraSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmApiFactory = FarmApiFactory;
/**
 * FarmApi - object-oriented interface
 * @export
 * @class FarmApi
 * @extends {BaseAPI}
 */
var FarmApi = /** @class */ (function (_super) {
    __extends(FarmApi, _super);
    function FarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create farm context.
     * @param {ICreateFarmContextRequestDTO} [iCreateFarmContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.createFarmContext = function (iCreateFarmContextRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).createFarmContext(iCreateFarmContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete farm context by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.deleteFarmContextByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).deleteFarmContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farm contexts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarmContexts = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarmContexts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farm lora settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarmLoraSettings = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarmLoraSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm context by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmContextByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm lora settings by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmLoraSettingsByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmLoraSettingsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm context by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmContextRequestDTO} [iUpdateFarmContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmContextByID = function (id, iUpdateFarmContextRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmContextByID(id, iUpdateFarmContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm lora settings by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmLoraSettingsRequestDTO} [iUpdateFarmLoraSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmLoraSettingsByID = function (id, iUpdateFarmLoraSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmLoraSettingsByID(id, iUpdateFarmLoraSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmApi;
}(base_1.BaseAPI));
exports.FarmApi = FarmApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/health-check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * MulticastGroupApi - axios parameter creator
 * @export
 */
var MulticastGroupApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create multicast group.
         * @param {ICreateMulticastGroupRequestDTO} [iCreateMulticastGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMulticastGroup: function (iCreateMulticastGroupRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/multicast-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateMulticastGroupRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete multicast group by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMulticastGroupByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteMulticastGroupByID', 'id', id);
                    localVarPath = "/message/multicast-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all multicast group settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMulticastGroupSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/multicast-group/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all multicast groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMulticastGroups: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/multicast-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get multicast group by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMulticastGroupByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getMulticastGroupByID', 'id', id);
                    localVarPath = "/message/multicast-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get multicast group settings by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMulticastGroupSettingsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getMulticastGroupSettingsByID', 'id', id);
                    localVarPath = "/message/multicast-group/settings/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update multicast group settings by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {IUpdateMulticastGroupSettingsRequestDTO} [iUpdateMulticastGroupSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMulticastGroupSettingsByID: function (id, iUpdateMulticastGroupSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateMulticastGroupSettingsByID', 'id', id);
                    localVarPath = "/message/multicast-group/settings/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateMulticastGroupSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MulticastGroupApiAxiosParamCreator = MulticastGroupApiAxiosParamCreator;
/**
 * MulticastGroupApi - functional programming interface
 * @export
 */
var MulticastGroupApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MulticastGroupApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create multicast group.
         * @param {ICreateMulticastGroupRequestDTO} [iCreateMulticastGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMulticastGroup: function (iCreateMulticastGroupRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMulticastGroup(iCreateMulticastGroupRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete multicast group by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMulticastGroupByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteMulticastGroupByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all multicast group settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMulticastGroupSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllMulticastGroupSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all multicast groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMulticastGroups: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllMulticastGroups(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get multicast group by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMulticastGroupByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMulticastGroupByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get multicast group settings by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMulticastGroupSettingsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMulticastGroupSettingsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update multicast group settings by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {IUpdateMulticastGroupSettingsRequestDTO} [iUpdateMulticastGroupSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMulticastGroupSettingsByID: function (id, iUpdateMulticastGroupSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMulticastGroupSettingsByID(id, iUpdateMulticastGroupSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MulticastGroupApiFp = MulticastGroupApiFp;
/**
 * MulticastGroupApi - factory interface
 * @export
 */
var MulticastGroupApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MulticastGroupApiFp)(configuration);
    return {
        /**
         * Create multicast group.
         * @param {ICreateMulticastGroupRequestDTO} [iCreateMulticastGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMulticastGroup: function (iCreateMulticastGroupRequestDTO, options) {
            return localVarFp.createMulticastGroup(iCreateMulticastGroupRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete multicast group by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMulticastGroupByID: function (id, options) {
            return localVarFp.deleteMulticastGroupByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all multicast group settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMulticastGroupSettings: function (options) {
            return localVarFp.getAllMulticastGroupSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all multicast groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMulticastGroups: function (options) {
            return localVarFp.getAllMulticastGroups(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get multicast group by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMulticastGroupByID: function (id, options) {
            return localVarFp.getMulticastGroupByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get multicast group settings by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMulticastGroupSettingsByID: function (id, options) {
            return localVarFp.getMulticastGroupSettingsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update multicast group settings by ID.
         * @param {string} id Unique ID of multicast group.
         * @param {IUpdateMulticastGroupSettingsRequestDTO} [iUpdateMulticastGroupSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMulticastGroupSettingsByID: function (id, iUpdateMulticastGroupSettingsRequestDTO, options) {
            return localVarFp.updateMulticastGroupSettingsByID(id, iUpdateMulticastGroupSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MulticastGroupApiFactory = MulticastGroupApiFactory;
/**
 * MulticastGroupApi - object-oriented interface
 * @export
 * @class MulticastGroupApi
 * @extends {BaseAPI}
 */
var MulticastGroupApi = /** @class */ (function (_super) {
    __extends(MulticastGroupApi, _super);
    function MulticastGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create multicast group.
     * @param {ICreateMulticastGroupRequestDTO} [iCreateMulticastGroupRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.createMulticastGroup = function (iCreateMulticastGroupRequestDTO, options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).createMulticastGroup(iCreateMulticastGroupRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete multicast group by ID.
     * @param {string} id Unique ID of multicast group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.deleteMulticastGroupByID = function (id, options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).deleteMulticastGroupByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all multicast group settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.getAllMulticastGroupSettings = function (options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).getAllMulticastGroupSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all multicast groups.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.getAllMulticastGroups = function (options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).getAllMulticastGroups(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get multicast group by ID.
     * @param {string} id Unique ID of multicast group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.getMulticastGroupByID = function (id, options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).getMulticastGroupByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get multicast group settings by ID.
     * @param {string} id Unique ID of multicast group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.getMulticastGroupSettingsByID = function (id, options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).getMulticastGroupSettingsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update multicast group settings by ID.
     * @param {string} id Unique ID of multicast group.
     * @param {IUpdateMulticastGroupSettingsRequestDTO} [iUpdateMulticastGroupSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MulticastGroupApi
     */
    MulticastGroupApi.prototype.updateMulticastGroupSettingsByID = function (id, iUpdateMulticastGroupSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.MulticastGroupApiFp)(this.configuration).updateMulticastGroupSettingsByID(id, iUpdateMulticastGroupSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MulticastGroupApi;
}(base_1.BaseAPI));
exports.MulticastGroupApi = MulticastGroupApi;
/**
 * SlotGroupApi - axios parameter creator
 * @export
 */
var SlotGroupApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create slot group.
         * @param {ICreateSlotGroupRequestDTO} [iCreateSlotGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotGroup: function (iCreateSlotGroupRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/slot-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateSlotGroupRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create slot group mapping.
         * @param {ICreateSlotGroupMappingRequestDTO} [iCreateSlotGroupMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotGroupMapping: function (iCreateSlotGroupMappingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/slot-group/mapping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateSlotGroupMappingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotGroupByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSlotGroupByID', 'id', id);
                    localVarPath = "/message/slot-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete slot group mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotGroupMappingByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSlotGroupMappingByFarmID', 'farmId', farmId);
                    localVarPath = "/message/slot-group/mapping/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all slot group mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupMappings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/slot-group/mapping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all slot group mappings by slot group ID.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupMappingsBySlotGroupID: function (slotGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'slotGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllSlotGroupMappingsBySlotGroupID', 'slotGroupId', slotGroupId);
                    localVarPath = "/message/slot-group/mapping/slot-group/{slotGroupId}"
                        .replace("{".concat("slotGroupId", "}"), encodeURIComponent(String(slotGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all slot group settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupSettings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/slot-group/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all slot groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroups: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/slot-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getSlotGroupByID', 'id', id);
                    localVarPath = "/message/slot-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get slot group mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupMappingByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getSlotGroupMappingByFarmID', 'farmId', farmId);
                    localVarPath = "/message/slot-group/mapping/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get slot group settings by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupSettingsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getSlotGroupSettingsByID', 'id', id);
                    localVarPath = "/message/slot-group/settings/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {IUpdateSlotGroupRequestDTO} [iUpdateSlotGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotGroupByID: function (id, iUpdateSlotGroupRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateSlotGroupByID', 'id', id);
                    localVarPath = "/message/slot-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateSlotGroupRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update slot group settings by ID.
         * @param {string} id Unique ID of slot group.
         * @param {IUpdateSlotGroupSettingsRequestDTO} [iUpdateSlotGroupSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotGroupSettingsByID: function (id, iUpdateSlotGroupSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateSlotGroupSettingsByID', 'id', id);
                    localVarPath = "/message/slot-group/settings/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateSlotGroupSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SlotGroupApiAxiosParamCreator = SlotGroupApiAxiosParamCreator;
/**
 * SlotGroupApi - functional programming interface
 * @export
 */
var SlotGroupApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SlotGroupApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create slot group.
         * @param {ICreateSlotGroupRequestDTO} [iCreateSlotGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotGroup: function (iCreateSlotGroupRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSlotGroup(iCreateSlotGroupRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create slot group mapping.
         * @param {ICreateSlotGroupMappingRequestDTO} [iCreateSlotGroupMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotGroupMapping: function (iCreateSlotGroupMappingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSlotGroupMapping(iCreateSlotGroupMappingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotGroupByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSlotGroupByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete slot group mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotGroupMappingByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSlotGroupMappingByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all slot group mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupMappings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSlotGroupMappings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all slot group mappings by slot group ID.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupMappingsBySlotGroupID: function (slotGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSlotGroupMappingsBySlotGroupID(slotGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all slot group settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupSettings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSlotGroupSettings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all slot groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroups: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSlotGroups(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSlotGroupByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get slot group mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupMappingByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSlotGroupMappingByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get slot group settings by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupSettingsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSlotGroupSettingsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {IUpdateSlotGroupRequestDTO} [iUpdateSlotGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotGroupByID: function (id, iUpdateSlotGroupRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSlotGroupByID(id, iUpdateSlotGroupRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update slot group settings by ID.
         * @param {string} id Unique ID of slot group.
         * @param {IUpdateSlotGroupSettingsRequestDTO} [iUpdateSlotGroupSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotGroupSettingsByID: function (id, iUpdateSlotGroupSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSlotGroupSettingsByID(id, iUpdateSlotGroupSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SlotGroupApiFp = SlotGroupApiFp;
/**
 * SlotGroupApi - factory interface
 * @export
 */
var SlotGroupApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SlotGroupApiFp)(configuration);
    return {
        /**
         * Create slot group.
         * @param {ICreateSlotGroupRequestDTO} [iCreateSlotGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotGroup: function (iCreateSlotGroupRequestDTO, options) {
            return localVarFp.createSlotGroup(iCreateSlotGroupRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create slot group mapping.
         * @param {ICreateSlotGroupMappingRequestDTO} [iCreateSlotGroupMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotGroupMapping: function (iCreateSlotGroupMappingRequestDTO, options) {
            return localVarFp.createSlotGroupMapping(iCreateSlotGroupMappingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotGroupByID: function (id, options) {
            return localVarFp.deleteSlotGroupByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete slot group mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotGroupMappingByFarmID: function (farmId, options) {
            return localVarFp.deleteSlotGroupMappingByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all slot group mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupMappings: function (options) {
            return localVarFp.getAllSlotGroupMappings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all slot group mappings by slot group ID.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupMappingsBySlotGroupID: function (slotGroupId, options) {
            return localVarFp.getAllSlotGroupMappingsBySlotGroupID(slotGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all slot group settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroupSettings: function (options) {
            return localVarFp.getAllSlotGroupSettings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all slot groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotGroups: function (options) {
            return localVarFp.getAllSlotGroups(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupByID: function (id, options) {
            return localVarFp.getSlotGroupByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get slot group mapping by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupMappingByFarmID: function (farmId, options) {
            return localVarFp.getSlotGroupMappingByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get slot group settings by ID.
         * @param {string} id Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotGroupSettingsByID: function (id, options) {
            return localVarFp.getSlotGroupSettingsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update slot group by ID.
         * @param {string} id Unique ID of slot group.
         * @param {IUpdateSlotGroupRequestDTO} [iUpdateSlotGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotGroupByID: function (id, iUpdateSlotGroupRequestDTO, options) {
            return localVarFp.updateSlotGroupByID(id, iUpdateSlotGroupRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update slot group settings by ID.
         * @param {string} id Unique ID of slot group.
         * @param {IUpdateSlotGroupSettingsRequestDTO} [iUpdateSlotGroupSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotGroupSettingsByID: function (id, iUpdateSlotGroupSettingsRequestDTO, options) {
            return localVarFp.updateSlotGroupSettingsByID(id, iUpdateSlotGroupSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SlotGroupApiFactory = SlotGroupApiFactory;
/**
 * SlotGroupApi - object-oriented interface
 * @export
 * @class SlotGroupApi
 * @extends {BaseAPI}
 */
var SlotGroupApi = /** @class */ (function (_super) {
    __extends(SlotGroupApi, _super);
    function SlotGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create slot group.
     * @param {ICreateSlotGroupRequestDTO} [iCreateSlotGroupRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.createSlotGroup = function (iCreateSlotGroupRequestDTO, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).createSlotGroup(iCreateSlotGroupRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create slot group mapping.
     * @param {ICreateSlotGroupMappingRequestDTO} [iCreateSlotGroupMappingRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.createSlotGroupMapping = function (iCreateSlotGroupMappingRequestDTO, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).createSlotGroupMapping(iCreateSlotGroupMappingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete slot group by ID.
     * @param {string} id Unique ID of slot group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.deleteSlotGroupByID = function (id, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).deleteSlotGroupByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete slot group mapping by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.deleteSlotGroupMappingByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).deleteSlotGroupMappingByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all slot group mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getAllSlotGroupMappings = function (options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getAllSlotGroupMappings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all slot group mappings by slot group ID.
     * @param {string} slotGroupId Unique ID of slot group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getAllSlotGroupMappingsBySlotGroupID = function (slotGroupId, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getAllSlotGroupMappingsBySlotGroupID(slotGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all slot group settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getAllSlotGroupSettings = function (options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getAllSlotGroupSettings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all slot groups.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getAllSlotGroups = function (options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getAllSlotGroups(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get slot group by ID.
     * @param {string} id Unique ID of slot group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getSlotGroupByID = function (id, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getSlotGroupByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get slot group mapping by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getSlotGroupMappingByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getSlotGroupMappingByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get slot group settings by ID.
     * @param {string} id Unique ID of slot group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.getSlotGroupSettingsByID = function (id, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).getSlotGroupSettingsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update slot group by ID.
     * @param {string} id Unique ID of slot group.
     * @param {IUpdateSlotGroupRequestDTO} [iUpdateSlotGroupRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.updateSlotGroupByID = function (id, iUpdateSlotGroupRequestDTO, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).updateSlotGroupByID(id, iUpdateSlotGroupRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update slot group settings by ID.
     * @param {string} id Unique ID of slot group.
     * @param {IUpdateSlotGroupSettingsRequestDTO} [iUpdateSlotGroupSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotGroupApi
     */
    SlotGroupApi.prototype.updateSlotGroupSettingsByID = function (id, iUpdateSlotGroupSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.SlotGroupApiFp)(this.configuration).updateSlotGroupSettingsByID(id, iUpdateSlotGroupSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SlotGroupApi;
}(base_1.BaseAPI));
exports.SlotGroupApi = SlotGroupApi;
/**
 * SlotTargetApi - axios parameter creator
 * @export
 */
var SlotTargetApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Calibrate and update all slot targets by slot group ID. Will handle all end devices mapped to the slot group and update or delete them if necessary.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calibrateAllSlotTargetsBySlotGroupID: function (slotGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'slotGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('calibrateAllSlotTargetsBySlotGroupID', 'slotGroupId', slotGroupId);
                    localVarPath = "/message/slot-target/slot-group/{slotGroupId}"
                        .replace("{".concat("slotGroupId", "}"), encodeURIComponent(String(slotGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete slot target by end device ID.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotTargetByEndDeviceID: function (endDeviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'endDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSlotTargetByEndDeviceID', 'endDeviceId', endDeviceId);
                    localVarPath = "/message/slot-target/end-device/{endDeviceId}"
                        .replace("{".concat("endDeviceId", "}"), encodeURIComponent(String(endDeviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all slot targets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotTargets: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/message/slot-target";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all slot targets by slot group ID.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotTargetsBySlotGroupID: function (slotGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'slotGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllSlotTargetsBySlotGroupID', 'slotGroupId', slotGroupId);
                    localVarPath = "/message/slot-target/slot-group/{slotGroupId}"
                        .replace("{".concat("slotGroupId", "}"), encodeURIComponent(String(slotGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get slot target by end device ID.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotTargetByEndDeviceID: function (endDeviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'endDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getSlotTargetByEndDeviceID', 'endDeviceId', endDeviceId);
                    localVarPath = "/message/slot-target/end-device/{endDeviceId}"
                        .replace("{".concat("endDeviceId", "}"), encodeURIComponent(String(endDeviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update slot target by end device ID. Will create if slot target does not exist.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {IUpdateSlotTargetRequestDTO} [iUpdateSlotTargetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotTargetByEndDeviceID: function (endDeviceId, iUpdateSlotTargetRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'endDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSlotTargetByEndDeviceID', 'endDeviceId', endDeviceId);
                    localVarPath = "/message/slot-target/end-device/{endDeviceId}"
                        .replace("{".concat("endDeviceId", "}"), encodeURIComponent(String(endDeviceId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateSlotTargetRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SlotTargetApiAxiosParamCreator = SlotTargetApiAxiosParamCreator;
/**
 * SlotTargetApi - functional programming interface
 * @export
 */
var SlotTargetApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SlotTargetApiAxiosParamCreator)(configuration);
    return {
        /**
         * Calibrate and update all slot targets by slot group ID. Will handle all end devices mapped to the slot group and update or delete them if necessary.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calibrateAllSlotTargetsBySlotGroupID: function (slotGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.calibrateAllSlotTargetsBySlotGroupID(slotGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete slot target by end device ID.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotTargetByEndDeviceID: function (endDeviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSlotTargetByEndDeviceID(endDeviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all slot targets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotTargets: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSlotTargets(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all slot targets by slot group ID.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotTargetsBySlotGroupID: function (slotGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSlotTargetsBySlotGroupID(slotGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get slot target by end device ID.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotTargetByEndDeviceID: function (endDeviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSlotTargetByEndDeviceID(endDeviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update slot target by end device ID. Will create if slot target does not exist.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {IUpdateSlotTargetRequestDTO} [iUpdateSlotTargetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotTargetByEndDeviceID: function (endDeviceId, iUpdateSlotTargetRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSlotTargetByEndDeviceID(endDeviceId, iUpdateSlotTargetRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SlotTargetApiFp = SlotTargetApiFp;
/**
 * SlotTargetApi - factory interface
 * @export
 */
var SlotTargetApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SlotTargetApiFp)(configuration);
    return {
        /**
         * Calibrate and update all slot targets by slot group ID. Will handle all end devices mapped to the slot group and update or delete them if necessary.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calibrateAllSlotTargetsBySlotGroupID: function (slotGroupId, options) {
            return localVarFp.calibrateAllSlotTargetsBySlotGroupID(slotGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete slot target by end device ID.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotTargetByEndDeviceID: function (endDeviceId, options) {
            return localVarFp.deleteSlotTargetByEndDeviceID(endDeviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all slot targets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotTargets: function (options) {
            return localVarFp.getAllSlotTargets(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all slot targets by slot group ID.
         * @param {string} slotGroupId Unique ID of slot group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSlotTargetsBySlotGroupID: function (slotGroupId, options) {
            return localVarFp.getAllSlotTargetsBySlotGroupID(slotGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get slot target by end device ID.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotTargetByEndDeviceID: function (endDeviceId, options) {
            return localVarFp.getSlotTargetByEndDeviceID(endDeviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update slot target by end device ID. Will create if slot target does not exist.
         * @param {string} endDeviceId Unique ID of end device.
         * @param {IUpdateSlotTargetRequestDTO} [iUpdateSlotTargetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotTargetByEndDeviceID: function (endDeviceId, iUpdateSlotTargetRequestDTO, options) {
            return localVarFp.updateSlotTargetByEndDeviceID(endDeviceId, iUpdateSlotTargetRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SlotTargetApiFactory = SlotTargetApiFactory;
/**
 * SlotTargetApi - object-oriented interface
 * @export
 * @class SlotTargetApi
 * @extends {BaseAPI}
 */
var SlotTargetApi = /** @class */ (function (_super) {
    __extends(SlotTargetApi, _super);
    function SlotTargetApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Calibrate and update all slot targets by slot group ID. Will handle all end devices mapped to the slot group and update or delete them if necessary.
     * @param {string} slotGroupId Unique ID of slot group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotTargetApi
     */
    SlotTargetApi.prototype.calibrateAllSlotTargetsBySlotGroupID = function (slotGroupId, options) {
        var _this = this;
        return (0, exports.SlotTargetApiFp)(this.configuration).calibrateAllSlotTargetsBySlotGroupID(slotGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete slot target by end device ID.
     * @param {string} endDeviceId Unique ID of end device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotTargetApi
     */
    SlotTargetApi.prototype.deleteSlotTargetByEndDeviceID = function (endDeviceId, options) {
        var _this = this;
        return (0, exports.SlotTargetApiFp)(this.configuration).deleteSlotTargetByEndDeviceID(endDeviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all slot targets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotTargetApi
     */
    SlotTargetApi.prototype.getAllSlotTargets = function (options) {
        var _this = this;
        return (0, exports.SlotTargetApiFp)(this.configuration).getAllSlotTargets(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all slot targets by slot group ID.
     * @param {string} slotGroupId Unique ID of slot group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotTargetApi
     */
    SlotTargetApi.prototype.getAllSlotTargetsBySlotGroupID = function (slotGroupId, options) {
        var _this = this;
        return (0, exports.SlotTargetApiFp)(this.configuration).getAllSlotTargetsBySlotGroupID(slotGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get slot target by end device ID.
     * @param {string} endDeviceId Unique ID of end device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotTargetApi
     */
    SlotTargetApi.prototype.getSlotTargetByEndDeviceID = function (endDeviceId, options) {
        var _this = this;
        return (0, exports.SlotTargetApiFp)(this.configuration).getSlotTargetByEndDeviceID(endDeviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update slot target by end device ID. Will create if slot target does not exist.
     * @param {string} endDeviceId Unique ID of end device.
     * @param {IUpdateSlotTargetRequestDTO} [iUpdateSlotTargetRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlotTargetApi
     */
    SlotTargetApi.prototype.updateSlotTargetByEndDeviceID = function (endDeviceId, iUpdateSlotTargetRequestDTO, options) {
        var _this = this;
        return (0, exports.SlotTargetApiFp)(this.configuration).updateSlotTargetByEndDeviceID(endDeviceId, iUpdateSlotTargetRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SlotTargetApi;
}(base_1.BaseAPI));
exports.SlotTargetApi = SlotTargetApi;
